const heading5 = [
  "M3.78 11.2V8.53H6.7v2.69h1.23V4.68H6.7v2.68H3.78V4.68H2.55v6.53zm7.4.12a2.4 2.4 0 0 0 1.58-.6c.42-.4.69-.99.7-1.57a2.05 2.05 0 0 0-.67-1.6 2.25 2.25 0 0 0-1.42-.52c-.28 0-.62.07-.9.22l.07-1.42h2.48V4.68H9.45l-.2 3.47 1.05.31c.14-.13.42-.34.89-.33.27 0 .54.1.72.3a1.02 1.02 0 0 1 0 1.45 1.02 1.02 0 0 1-1.7-.46l-1.2.3a2.22 2.22 0 0 0 2.18 1.6z"
];
export {
  heading5
};
//# sourceMappingURL=heading5.js.map
